module.exports = __webpack_public_path__ + "static/media/picto-circles-blue.56ac42f3.svg";